import {
  IconAnalytics,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconCar,
  IconCctvLine,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconChartRadiusGray,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo3.mp4';
import subVideo4 from '@src/assets/images/solution/manufacturingProcess/video/sub/rtlsVideo4.mp4';

import image1 from '@src/assets/images/solution/manufacturingProcess/img/1.avif';
import image2 from '@src/assets/images/solution/manufacturingProcess/img/2.avif';
import image3 from '@src/assets/images/solution/manufacturingProcess/img/3.avif';
import image4 from '@src/assets/images/solution/manufacturingProcess/img/4.avif';
import image5 from '@src/assets/images/solution/manufacturingProcess/img/5.avif';
import image6 from '@src/assets/images/solution/manufacturingProcess/img/6.avif';
import { manufacturingProcess1, manufacturingProcess2, manufacturingProcess3, recommendationServer } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '제조 솔루션',
  banner: {
    title: '공정 내 자산의 실시간 위치로 작업 흐름을 최적화하세요',
    desc: '실시간 위치 정보로 작업자와 자산의 공정별 이동을 추적하고 병목 구간을 조기에 식별합니다',
  },

  recommend: {
    title: '위치 태그로 작업 흐름을 실시간 추적하고 공정 병목을 자동 감지합니다',
    desc: '작업자와 자산에 부착된 태그가 공정별 위치를 수집하고, 수신기를 통해 이동 경로와 체류 이력이 자동 저장됩니다',
    labels: {
      desktop: [
        {
          img: manufacturingProcess1,
          data: recommendation.twintarckerBLE,
        },
        {
          img: manufacturingProcess2,
          data: recommendation.plutoconPro,
        },
        {
          img: manufacturingProcess3,
          data: recommendation.co2,
        },
        {
          img: recommendationServer,
          data: recommendation.server,
        },
      ],
      mobile: [
        {
          data: recommendation.twintarckerBLE,
        },
        {
          data: recommendation.plutoconPro,
        },
        {
          data: recommendation.co2,
        },
        {
          data: recommendation.server,
        },
      ],
    },
  },

  video: {
    title: '복잡한 물류 환경에서도 AI를 통해 실시간으로 재고 자산 현황을 관리하세요.',
    desc: '기존 수작업 카운팅 방식은 복잡한 물류 환경에서 효율적이지 않고 오류가 잦았습니다. ORBRO의 AI 시스템은 철강코일과 같은 다양한 물류 자산을 자동으로 식별하고 정확하게 관리하여, 창고 운영의 효율성을 높입니다.',
    play: video,
  },

  func: [
    {
      theme: '실시간 공정 데이터를 통해 생산성을 효과적으로 향상시키세요.',
      title: '작공정별 작업 현황 실시간 모니터링',
      desc: '각 공정의 진행 상황을 실시간으로 정확히 파악하여 생산 지연을 방지하고 신속히 대응합니다. 실시간 데이터를 통해 현장 관리 효율성을 극대화하고 생산성을 높일 수 있습니다.',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      image: image1,
    },
    {
      title: '공정별 소요 시간의 정확한 분석',
      desc: '모든 공정의 작업 소요 시간을 정확히 측정하고 분석하여 병목 구간을 빠르게 발견하고 해결합니다. 이를 통해 생산성을 지속적으로 개선하고 운영 효율을 높입니다.',
      sub1: '실시간 위치 추적',
      icon1: IconBinocularsGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: '작업자 업무능력 데이터 기반 평가',
      desc: '작업자의 공정별 업무 데이터를 분석하여 정확한 성과 평가와 업무 능력 향상을 지원합니다. 데이터 기반의 객관적 평가를 통해 운영 성과를 지속적으로 높입니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconChartRadiusGray,
      image: image3,
    },
    {
      title: '공간별 작업 현황 확인',
      desc: '관리자에게 모바일 앱을 통해 실시간으로 공정 현황 및 문제 발생 알림을 제공합니다. 신속한 현장 대응을 가능하게 하여 생산 중단을 최소화하고 운영 안정성을 확보합니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      video: subVideo1,
    },
    {
      theme: '데이터 기반의 스마트한 공정 관리로 운영 효율성을 높이세요.',
      title: 'ERP 시스템과의 효율적 연동',
      desc: 'ERP 시스템과 실시간 연동하여 공정 데이터를 통합적으로 관리하고 운영의 효율성을 극대화합니다. 통합 데이터를 기반으로 신속한 의사결정과 운영 최적화를 지원합니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '대응 방식 설정',
      icon2: IconChartRadiusGray,
      image: image4,
    },
    {
      title: '공장 공정 효율적 재배치 지원',
      desc: '작업자와 자산의 이동 데이터를 분석하여 공장의 공정 및 설비를 효율적으로 재배치할 수 있습니다. 데이터 기반의 재배치로 작업 효율성을 높이고 생산성과 운영 비용을 최적화합니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      video: subVideo2,
    },
    {
      title: '설치 환경의 유연한 적용성',
      desc: '철골 구조물, 야외 텐트 등 특수한 설치 환경에서도 위치 데이터를 정확히 측정합니다. 이를 통해 현장 특성과 상관없이 안정적인 공정 관리가 가능합니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      image: image5,
    },
    {
      title: '열악한 통신 환경에서도 안정적 운영',
      desc: '통신 신호가 약한 열악한 환경에서도 안정적인 데이터 수신과 실시간 위치 추적이 가능합니다. 신뢰도 높은 데이터를 바탕으로 생산성을 유지할 수 있습니다.',
      sub1: '데이터 클라우드 저장',
      icon1: IconClockGray,
      sub2: '통계 데이터 제공',
      icon2: IconChartBarGray,
      image: image6,
    },
  ],
  subfunc: {
    title: '다양한 기능',
    desc: '공정 라인의 생산성은 제조 산업의 핵심이라 할 수 있습니다. 오브로가 제공하는 기능들은 공정 라인의 효율성과 생산성을 모두 한층 더 끌어 올릴 수 있습니다.',

    data: [
      {
        icon: IconLayers, // 공정 현황 표시 → 시각화/진행 상태
        title: '공정 현황 실시간 표시',
        desc: '진행 중인 작업 현황을 실시간으로 파악해 지연 발생 전 병목을 사전 감지합니다.',
      },
      {
        icon: IconAnalytics, // 공정 시간 기록 → 정량 기록/분석
        title: '공정 시간 자동 기록',
        desc: '각 공정의 실제 소요 시간을 자동 기록해 병목 원인을 정량적으로 분석합니다.',
      },
      {
        icon: IconAnalytics, // 작업자 성과 → 분석 및 평가
        title: '작업자별 성과 평가',
        desc: '작업자의 투입 시간과 작업 빈도를 기록해 정량적 성과 평가를 지원합니다.',
      },
      {
        icon: IconWarning, // 알림 → 실시간 이슈 대응
        title: '모바일 실시간 알림',
        desc: '문제 발생 시 관리자에게 모바일로 즉시 알림을 전송해 대응 속도를 높입니다.',
      },
      {
        icon: IconSearch, // ERP 연동 → 시스템 연동/탐색 의미
        title: 'ERP 시스템 연동',
        desc: '수집된 데이터를 ERP와 자동 연동해 생산계획 수립과 의사결정을 지원합니다.',
      },
      {
        icon: IconLayers, // 공정 재배치 → 레이아웃 개선
        title: '공정 재배치 분석',
        desc: '작업자와 자산의 이동 데이터를 분석해 공정 레이아웃 개선을 유도합니다.',
      },
      {
        icon: IconRoute, // 정밀 위치추적 → 이동 경로
        title: '정밀 위치추적 지원',
        desc: '철골 구조물이나 보조동 등 특수 환경에서도 안정적인 위치 수신이 가능합니다.',
      },
      {
        icon: IconSearch, // 통신 장애 대비 → 오프라인/데이터 보존
        title: '통신 장애 대비 운영',
        desc: '오프라인 환경에서도 데이터가 로컬 저장돼 재연결 시 자동 동기화됩니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'manufacturingSteel',
    },
    {
      data: 'logisticsAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
